import { motion } from "framer-motion";
import { EASE } from "@/lib/motion";

export default function SiteNav() {
  return (
    <motion.header
      className="site-nav"
      initial={{ y: -16, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: EASE }}
      data-testid="site-nav"
    >
      <a href="/" className="brand" data-testid="nav-brand">
        <img src="/assets/logo.png" alt="" width="42" height="42" />
        <span>
          Blankwater<small>ONTRUIMING &amp; HERGEBRUIK</small>
        </span>
      </a>
      <nav aria-label="Hoofdnavigatie">
        <a href="#diensten" data-testid="nav-diensten">Diensten</a>
        <a href="#werkwijze" data-testid="nav-werkwijze">Werkwijze</a>
        <a href="#over" data-testid="nav-over">Over ons</a>
      </nav>
      <a className="nav-arrow" href="#offerte" data-testid="nav-offerte-cta">
        Offerte aanvragen <span aria-hidden="true">↗</span>
      </a>
    </motion.header>
  );
}
